module.exports = __webpack_public_path__ + "img/fallback-slide.3840x1280.en.627f1285.png";